import { createContext } from 'react';
import axios from '../../../../../api/axios';

export const store = createContext(null);
export const initialState = {
    loaded:false,
    inProgress:false,
    cities:null,
    search:{title:null,state:null},
    selected:null,
    page:1,
    dialog:false,
}
export const reducer = (state,actions)=>{
    const {payload,type} = actions;
    switch (type) {
        case 'LOADED':
            return {...state,loaded:payload}
        case 'IN_PROGRESS':
            return {...state,inProgress:payload};
        case 'CITIES':
            return {...state,cities:payload,loaded:true,inProgress:false}
        case 'SEARCH_CITY_NAME':
            return {...state,search:{...state.search,title:payload,inProgress:true}};
        case 'SEARCH_BY_STATE':
            return {...state,search:{...state.search,state:payload,inProgress:true}};
        case 'SELECT_CITY':
            return {...state,selected:payload};
        case 'PAGE':
            return {...state,page:payload,inProgress:true}
        case 'CLOSE_DIALOG':
            return {...state,dialog:false,selected:null};
        case 'OPEN_DIALOG':
            return {...state,dialog:true,selected:null};
        default:
            return {...state};
    }
}
export const actions = {
    fetchingCities:async function(page,itemsCountPerPage,title,state){
        try {
            let url = `/api/v1/admin/city/paginate/${page}/${itemsCountPerPage}?`;
            title && (url = url+`title=${title}`)
            state && (url = url+`state=${state}`)
            const {data} = await axios.get(url)
            return data;
        } catch (error) {
            throw error;
        }
    },
    addCity:async function(values){
        try {
            const response = await axios.post(`/api/v1/admin/parameters/cities/add`,{
                ...values
            });
            return response;
        } catch (error) {
            throw error;
        }
    },
    deleteCity:async function(id){},
    editCity:async function(id,data){}
}